import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { getDealStatusByStatusType } from '../../service/DealsHelpers/DealsHelpers';
import { dealStatus, dealStatusForFilter } from '../../typings/deals';
import { CompleteReason } from '../../typings/graphql-grid';

import './DealCellStatus.css';

export interface DealCellStatusProps {
    status: dealStatus;
    completeReason?: CompleteReason;
}

export class DealCellStatus extends React.Component<DealCellStatusProps> {
    render() {
        const { status, completeReason } = this.props;

        const mergedStatusReason = {
            [dealStatus.RECEIVED]: dealStatusForFilter.RECEIVED,
            [dealStatus.ACTIVE]: dealStatusForFilter.ACTIVE,
            [dealStatus.ARCHIVED]: dealStatusForFilter.ARCHIVED,
            [dealStatus.COMPLETED]: {
                [CompleteReason.BY_CLIENT]: dealStatusForFilter.COMPLETED_BY_CLIENT,
                [CompleteReason.BY_PUBLISHER]: dealStatusForFilter.COMPLETED_BY_PUBLISHER,
                [CompleteReason.BY_DATE]: dealStatusForFilter.COMPLETED_BY_DATE
            }[completeReason || CompleteReason.BY_CLIENT]
        }[status];

        return (
            <div className={Bem.cls('deal-cell-status')}>
                <div
                    className={Bem.cls('deal-cell-status', 'value', {
                        status: Bem.beminize(status)
                    })}
                >
                    {getDealStatusByStatusType(mergedStatusReason)}
                </div>
            </div>
        );
    }
}
